import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Swipeable from 'react-swipeable-views'
import styled from 'styled-components'
import { Box } from '../../Shared/Base'
import LinkSafe from '../../Shared/LinkSafe'
import { Dialog, DialogContent } from '@material-ui/core'
import { SvgIconArrowBack, SvgIconHeart, SvgIconShare } from '../../Shared/Svg/Alert'
import { IconClose } from '../../Shared/Svg/Icons'
import { proxy_image } from '../../../helpers/misc'

const no_pic_url =
  'https://res.cloudinary.com/loueragile/image/upload/v1588422076/web/no-picture.png'

const StyledDot = styled.button`
  height: 24px;
  width: 24px;
  cursor: pointer;
  border: 0px;
  outline: none;
  background: none;
  padding: 0px;
  margin-right: 5px;
  margin-left: 5px;

  div {
    background-color: ${props => props.color};
    opacity: ${props => (props.active ? 1 : 0.5)};
    height: 16px;
    width: 16px;
    border-radius: 100%;
    margin: 3px;
    border: 2px solid var(--colorLight);
  }
`

const Dot = ({ active, onClick, color }) => (
  <StyledDot active={active} onClick={onClick} color={color}>
    <div />
  </StyledDot>
)

const StyledDots = styled.div`
  position: ${props => props.position};
  left: 0;
  bottom: 15px;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
`

const Dots = ({ count, index, onClickDot, color = 'white', position = 'absolute' }) => (
  <StyledDots position={position}>
    {Array(count)
      .fill(null)
      .map((_, i) => (
        <Dot key={i} active={index === i} onClick={() => onClickDot(i)} color={color} />
      ))}
  </StyledDots>
)

const Carousel = ({ images, index, onChangeIndex, onClickImage }) => {
  return (
    <Box pt="66.67%">
      <Box top="0" position="absolute" width="100%" height="100%">
        <Swipeable
          // enableMouseEvents
          containerStyle={{ height: '100%' }}
          style={{ height: '100%' }}
          onChangeIndex={onChangeIndex}
          index={index}
        >
          {images.map((src, i) => (
            <Box
              as="img"
              key={i}
              alt="logement"
              className="img-rwd"
              style={{ objectFit: 'cover' }}
              src={proxy_image(src) || no_pic_url}
              onClick={onClickImage}
              onError={e => {
                if (e.target.src !== no_pic_url) {
                  e.target.src = no_pic_url
                }
              }}
            />
          ))}
        </Swipeable>
        {images.length > 1 && (
          <Dots count={images.length} index={index} onClickDot={onChangeIndex} />
        )}
      </Box>
    </Box>
  )
}

const AlertResultModalMobilePhotos = React.memo(
  ({ images, index, open, onClose, onChangeIndex }) => {
    return (
      <Dialog
        fullScreen
        open={open}
        PaperProps={{ style: { background: '#F9F9F9' } }}
        onClose={onClose}
      >
        <Box position="absolute" top={0} lef={0} right={0} textAlign="right" p={10} zIndex="2">
          <Box
            as="button"
            color="light"
            borderRadius={100}
            border="1px solid"
            borderColor="thin"
            backgroundColor="white"
            width={50}
            height={50}
            display="flex"
            justifyContent="center"
            alignItems="center"
            onClick={onClose}
          >
            <IconClose width={20} height={20} fill="var(--colorLight)" />
          </Box>
        </Box>
        <DialogContent style={{ padding: '0' }}>
          <Box>
            <Swipeable
              enableMouseEvents
              containerStyle={{ height: '100%' }}
              style={{ height: '100%' }}
              onChangeIndex={onChangeIndex}
              index={index}
            >
              {images.map((src, i) => (
                <Box
                  key={i}
                  height="calc(100vh - 60px);"
                  flex="1"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Box
                    as="img"
                    src={proxy_image(src)}
                    alt="logement"
                    style={{ maxHeight: '100%', objectFit: 'cover' }}
                    onError={e => {
                      if (e.target.src !== no_pic_url) {
                        e.target.src = no_pic_url
                      }
                    }}
                  />
                </Box>
              ))}
            </Swipeable>
          </Box>
        </DialogContent>
        <Box
          position="absolute"
          bottom={0}
          lef={0}
          right={0}
          p={12}
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          className="fls"
          maxHeight={72}
          width="100%"
        >
          {images.length > 1 && (
            <Dots
              count={images.length}
              index={index}
              onClickDot={onChangeIndex}
              color="var(--colorWhite)"
              position=""
            />
          )}
        </Box>
      </Dialog>
    )
  }
)

const AlertResultMobileTop = ({
  images,
  linkBack,
  is_favorite,
  og_url,
  onFavorite,
  onUnfavorite
}) => {
  const [index, set_index] = React.useState(0)
  const [modal_open, set_modal_open] = React.useState(false)
  const history = useHistory()
  const location = useLocation()
  const use_history_back = location.state && location.state.use_history_back

  const onChangeIndex = React.useCallback(index => {
    set_index(index)
  }, [])

  return (
    <Box width="100%" position="relative">
      <AlertResultModalMobilePhotos
        images={images}
        onChangeIndex={onChangeIndex}
        index={index}
        open={modal_open}
        onClose={() => set_modal_open(false)}
      />
      <Carousel
        images={images}
        onChangeIndex={onChangeIndex}
        index={index}
        onClickImage={() => set_modal_open(true)}
      />
      <Box display="flex" position="absolute" left={{ md: 30, xs: 20 }} top={{ md: 30, xs: 20 }}>
        {linkBack && (
          <Box
            as={LinkSafe}
            to={linkBack}
            onClick={e => {
              if (use_history_back) {
                e.preventDefault()
                history.goBack()
              }
            }}
            className="la_webview_hide"
            display="flex"
            alignItems="center"
            justifyContent="center"
            boxShadow={'0px 0px 30px 5px rgba(0,0,0,0.03);'}
            backgroundColor="white"
            borderRadius={200}
            width={40}
            height={40}
          >
            <SvgIconArrowBack />
          </Box>
        )}
        {window && window.navigator && window.navigator.share && og_url && (
          <Box
            as="button"
            className="la_webview_only"
            display="flex"
            alignItems="center"
            justifyContent="center"
            boxShadow={'0px 0px 30px 5px rgba(0,0,0,0.03);'}
            backgroundColor="white"
            borderRadius={200}
            width={40}
            height={40}
            onClick={() => window.navigator.share({ url: og_url })}
          >
            <SvgIconShare />
          </Box>
        )}
      </Box>
      {is_favorite !== undefined && Boolean(is_favorite) && (
        <Box
          onClick={onUnfavorite}
          as="button"
          className="fz-16"
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
          right={{ md: 30, xs: 20 }}
          top={{ md: 30, xs: 20 }}
          boxShadow={'0px 0px 30px 5px rgba(0,0,0,0.03);'}
          backgroundColor="white"
          borderRadius={200}
          width={40}
          height={40}
        >
          <SvgIconHeart color="var(--colorNegative)" />
        </Box>
      )}
      {is_favorite !== undefined && !Boolean(is_favorite) && (
        <Box
          onClick={onFavorite}
          as="button"
          className="fz-16"
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
          right={{ md: 30, xs: 20 }}
          top={{ md: 30, xs: 20 }}
          boxShadow={'0px 0px 30px 5px rgba(0,0,0,0.03);'}
          backgroundColor="white"
          borderRadius={200}
          width={40}
          height={40}
        >
          <SvgIconHeart color="var(--colorText)" />
        </Box>
      )}
    </Box>
  )
}

export default React.memo(AlertResultMobileTop)
